/** Adds the prefix to the `target` string if it is not empty  */
export function prefix<S extends string | null | undefined>(target: S, prefix: string) {
	return target ? prefix + target : target
}

/** Adds the suffix to the `target` string if it is not empty  */
export function suffix<S extends string | null | undefined>(target: S, suffix: string) {
	return target ? target + suffix : target
}

/** Removes all leading and trailing spaces and replaces multiple consecutive spaces with a single space. */
export function cleanSpaces(str?: string | null) {
	if (!str) {
		return str
	}
	return str.trim().replace(/\s+/g, ' ')
}
